import { useHookstate } from "@hookstate/core";
import { useUniversalFind } from "../../hooks/universal";
import { DisciplinaryCase, DisciplinaryCasesPageState } from "../../types";
import React from "react";
import DisciplinaryTableCases from "./DisciplinaryCases";
import { useDisciplinaryCases, useDisciplinaryHearings } from "../../hooks/demerit";
import { useGlobalMiscState } from "../../stores/misc";
import { updateMiscState, userHasRole } from "../../misc/utils";
import { HasRole } from "../HasRole";
import DefaultButton from "../default-button/DefaultButton";
import Tick from "../../assets/icons/Tick";
import Cross from "../../assets/icons/Cross";
import CalendarPlus from "../../assets/icons/CalendarPlus";
import Modal from "../Modal/Modal";
import InputField from "../input-field/InputField";
import { DisciplinaryHearingCreate } from "./DisciplinaryHearingCreate";
import { useGlobalUserState } from "../../stores/user";

export const DisciplinaryCasesPage = ({ type }: { type: string }) => {
  const userState = useGlobalUserState();
  const user = userState.get();
  const uniqUser = user.uniqUser || {};
  const miscState = useGlobalMiscState();
  const disciplinaryHearingCreateModalOpen = Boolean(
    miscState.get("disciplinaryHearingCreateModalOpen")
  );
  const disciplinaryCasesSelectedForHearings =
    miscState.get("disciplinaryCasesSelectedForHearings") || [];
  const disciplinaryCasesTriggerFetch: DisciplinaryCase =
    miscState.get("disciplinaryCasesTriggerFetch") || 0;
  const disciplinaryHearingsTriggerFetch =
    miscState.get("disciplinaryHearingsTriggerFetch") || 0;
  const allCases: DisciplinaryCase[] = useDisciplinaryCases(
    disciplinaryCasesTriggerFetch
  );
  const hearings: any[] = useDisciplinaryHearings(
    disciplinaryHearingsTriggerFetch
  );
  const caseIdsInHearings = new Set<number>(
    hearings.flatMap((h: any) => (h.cases || []).map((c: any) => c.id))
  );

  const cases = allCases
    .filter((c) => {
      // console.log("Filtering case", c, type);
      let retValue = !c.is_archived;

      // if (userHasRole('decide_on_disciplinary_cases')) {
      //     retValue = retValue && c.status === 0;
      // } else if (userHasRole('finalize_on_disciplinary_cases')) {
      //     retValue = retValue && c.status === 1;
      // }
      if (type === "decide_cases") {
        retValue = retValue && c.status === 0;
      } else if (type === "hearings_cases") {
        retValue =
          retValue && c.status === 1 && !caseIdsInHearings.has(c.id);
      } else if (type === "cases" && !userHasRole("view_cases_extended")) {
        retValue = retValue && c.created_by === uniqUser.id;
      }

      return retValue;
    })
    .sort((a, b) => a.id - b.id);

  const addAllForHearings = () => {
    miscState.set(
      "disciplinaryCasesSelectedForHearings",
      cases.map((c) => c.id)
    );
  };

  const removeAllFromHearings = () => {
    miscState.set("disciplinaryCasesSelectedForHearings", []);
  };

  const openHearingCreateModal = () => {
    miscState.set("disciplinaryHearingCreateModalOpen", true);
  };

  return (
    <div className='flex flex-col gap-4 flex-1'>
      {type === "hearings_cases" && (
        <HasRole roles={["create_hearings"]}>
          <div className='flex flex-row justify-between'>
            <div className='flex flex-row gap-2.5'>
              <DefaultButton
                Icon={Tick}
                buttonText='Выделить все'
                additionalStyle='min-w-[200px] py-2 px-5 gap-2 text-valley-dark-green border-valley-dark-green'
                iconStyle='w-6 h-6'
                onClick={addAllForHearings}
              />
              <DefaultButton
                Icon={Cross}
                buttonText='Сбросить выделение'
                additionalStyle='min-w-[200px] py-2 px-5 gap-2 text-valley-red border-valley-red'
                iconStyle='w-6 h-6'
                onClick={removeAllFromHearings}
              />
            </div>
            <DefaultButton
              Icon={CalendarPlus}
              buttonText='Назначить заседание'
              additionalStyle='py-2 px-6 gap-2 bg-valley-main text-white'
              disabled={!disciplinaryCasesSelectedForHearings.length}
              onClick={openHearingCreateModal}
            />
          </div>
        </HasRole>
      )}

      {cases.map((c) => (
        <DisciplinaryTableCases type={type} caseItem={c} />
      ))}
      <Modal
        additionalClassName='w-[32.5%] rounded-xl flex flex-col p-0'
        visible={disciplinaryHearingCreateModalOpen}
        setVisible={updateMiscState("disciplinaryHearingCreateModalOpen")}
      >
        <DisciplinaryHearingCreate />
      </Modal>
    </div>
  );
};
